<template>
    <paper class="person-info">
        <m-pane
                ref="tablePage"
                :config="config"
                :totalData="totalData"
                :pageTotal="pageTotal"
                :loading="loading"
                :searchTotalTitle="config.searchTotalTitle"
                :currentPage="currentPage"
                searchId="workPersonInfo"
                pageID="workPersonInfo02191"
                @edit-btn="editBtn"
                @create-account-btn="handleCreateAccount"
                @reset-password-btn="handleResetPassword"
                @bind-tenant-btn="handleBindTenant"
                @permission-btn="handlePermission"
                @row-db-click="rowDBclick"
                @selectChange="selectChange"
                @searchChange="searchChange"
                @pageChange="pageChange"
                @sizeChange="sizeChange">
            <div slot="table-module-btn" class="btn-box">
                <el-tooltip effect="dark" content="新增" placement="bottom" style="margin-left: 10px;" v-has="'08000201'">
                    <svg class="icon add-button" aria-hidden="true" @click="handleAdd">
                        <use xlink:href="#iconicon_newlyadd"></use>
                    </svg>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <span class="enable-btn" v-has="'08000203'">
                    <el-button type="primary" @click="handleEnable">启用联系人</el-button>
                </span>
                <span class="disable-btn" v-has="'08000202'">
                    <el-button type="primary" @click="handleDisable">停用联系人</el-button>
                </span>
                <span class="enable-btn" v-has="'08000203'">
                    <el-button type="primary" :loading="btnLoading" @click="handleEnableAccount">启用联系人账号</el-button>
                </span>
                <span class="disable-btn" v-has="'08000202'">
                    <el-button type="primary" :loading="btnLoading" @click="handleDisableAccount">停用联系人账号</el-button>
                </span>

            </div>
        </m-pane>
        <permission-dialog :openPermissionDialog="openPermissionDialog"
                           :manage="false"
                           :row="row"
                           @closeDialog="closePermissionDialog">
        </permission-dialog>
        <add-or-edit-contact-dialog
            :openAddOrEditDialog="openAddOrEditDialog"
            :id="id"
            :propertyNature="propertyNature"
            :manage="false"
            :supplierCode="supplierCode"
            :addOrEdit="addOrEdit"
            :isLgtPptSup="isLgtPptSup"
            @closeDialog="closeAddOrEditDialog"
            @confirmDialog="confirmAddOrEditDialog"
        ></add-or-edit-contact-dialog>
        <el-dialog
            class="tips-dialog"
            title="提示"
            :visible.sync="openTipsDialog"
            :close-on-click-modal="false"
            top="20%"
            width="350px"
            :before-close="handleTipsDialogClose">
            <span>{{tipsText}}</span>
        </el-dialog>
        <code-verify-dialog
            :visible="codeVisible"
            :userCode="row.userCode"
            :defaultMobile="row.contactsMobile"
            @close="codeVisible = false;"
            @confirm="handleCodeConfirm" />
    </paper>
</template>

<script>
import '@/styles/fonts/iconfont.js';
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import permissionDialog from '../../manage/keyData/tabs/person/PermissionDialog.vue';
import addOrEditContactDialog from '../../manage/keyData/tabs/person/AddOrEditContactDialog.vue';
import CodeVerifyDialog from '../../../../components/CodeVerifyDialog/Index';
import { enableToLabel, enableToStatus, accountTypeToLabel, userTypeToLabel, userTypeToStatus } from '../../../../utils/statusOrLabel.js';
import { LOGISTICS_SUPPLIER, COMPANY, PERSON } from '../../../../constant/constant.js';
import { dictWithUrl } from '@/components/lots/api';
import { getPersons, enablePersons,enableContactsUser,disableContactsUser, disablePersons, creatAccount, getLoginUser, resetPassword, bindTenant } from '../../../../api/register/person.js';
const THREE_HUNDRED = 300;
const FIVE_HUNDRED = 500;
export default {
    name: 'Index',
    components: { mPane, paper, permissionDialog, addOrEditContactDialog, CodeVerifyDialog },
    data() {
        return {
            dict: {},
            id: '',
            openAddOrEditDialog: false,
            addOrEdit: false,
            openPermissionDialog: false,
            row: {},
            selected: [],
            searchDataLists: {},
            dataObj: {},
            selectData: [],
            searchObj: {},
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            totalData: [],
            loading: false,
            labelPosition: 'right',
            supplierCode: '',
            propertyNature: '',
            openTipsDialog: false,
            closeOnClickModal: false,
            tipsText: '',
            btnLoading: false,
            codeVisible: false
        };
    },
    computed: {
        // 判断是否为物流法人供应商
        isLgtPptSup() {
            const { supplierType, propertyNature } = this.$store.state.supplier
            return supplierType === LOGISTICS_SUPPLIER && propertyNature === COMPANY
        },
        config() {
            const configTemp = JSON.parse(JSON.stringify(config))
            console.log(this.isLgtPptSup)
            if (!this.isLgtPptSup) {
                configTemp.table.columns = configTemp.table.columns.filter(item => !item.lgtpptVisible)
            }
            return configTemp
        },
    },
    methods: {
        load() {},
        editBtn(data) {},
        pageChange(data) {
            this.pageNo = data;
            this.handleGetPerson();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.handleGetPerson();
        },
        searchChange(data) {
            this.searchObj = data;
            this.pageNo = 1;
            this.handleGetPerson();
        },
        rowDBclick(row) {
            this.addOrEdit = false;
            this.id = String(row.id);
            this.openAddOrEditDialog = true;
        },
        selectChange(data) {
            this.selected = [].concat(data);
        },
        handleBindTenant(row) {
            const param = { userCode: row.userCode };
            bindTenant(JSON.stringify(param)).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('租户绑定成功！');
                    this.handleGetPerson();
                }
            });
        },
        /** 生成账号 **/
        handleCreateAccount(row) {
            if (row.userCode) {
                this.$message.warning('已有账号！');
            } else {
                creatAccount(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('生成成功！');
                        this.handleGetPerson();
                    }
                });
            }
        },
        /** 重置密码 **/
        handleResetPassword(row) {
            this.$confirm('是否确定对账号  ' + row.userCode + '  重置密码', '重置密码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.row = row;
                this.codeVisible = true;
            });
        },
        handleCodeConfirm(data) {
            const params = {
                userCode: this.row.userCode,
                operator: this.$store.state.user.userCode,
                email: this.row.contactsEmail,
                ...data
            };
            resetPassword(JSON.parse(JSON.stringify(params))).then(res => {
                if (res && res.code === '0') {
                    this.codeVisible = false;
                    setTimeout(() => {
                        const text = res.data.propertyNature === PERSON ? '手机短信' : '邮件验收';
                        this.tipsText = '账号：  ' + this.row.userCode + '  密码已重置，请查看' + text;
                        this.openTipsDialog = true;
                    }, FIVE_HUNDRED);
                }
            });
        },
        handleTipsDialogClose() {
            this.openTipsDialog = false;
        },
        /** 新增联系人 **/
        handleAdd() {
            this.addOrEdit = true;
            this.id = '';
            this.openAddOrEditDialog = true;
        },
        /** 启用 **/
        handleEnable() {
            if (this.selected.some((e) => enableToStatus(e.contactsStatus) === '0')) {
                this.$message.warning('勾选数据中有已启用数据');
            } else {
                this.handleBatchOperation('enable', '启用');
            }
        },
        /** 停用 **/
        handleDisable() {
            if (this.selected.some((e) => enableToStatus(e.contactsStatus) === '1')) {
                this.$message.warning('勾选数据中有已停用数据');
                return;
            }
            // if (this.selected.some((e) => e.userCode === null || e.userCode === '')) {
            //     this.$message.warning('该联系人没有账号，不必停用！');
            //     return;
            // }
            this.handleBatchOperation('disable', '停用');
        },
        /** 启用账号 **/
        handleEnableAccount() {
            if(this.selected.length){
                this.$confirm('确定启用该联系人的账号？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.btnLoading = true
                    enableContactsUser(JSON.stringify({ contactIdList: this.selected.map(v => v.id) })).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('启用成功')
                            this.handleGetPerson()
                        }
                    }).finally(() => {
                        this.btnLoading = false
                    })
                })
            }else{
                this.$message.warning('当前没有选中的数据')
            }
        },
        /** 停用账号 **/
        handleDisableAccount() {
            if(this.selected.length){
                this.$confirm('确定停用该联系人的账号？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.btnLoading = true
                    disableContactsUser(JSON.stringify({ contactIdList: this.selected.map(v => v.id) })).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('停用成功')
                            this.handleGetPerson()
                        }
                    }).finally(() => {
                        this.btnLoading = false
                    })
                })
            }else{
                this.$message.warning('当前没有选中的数据')
            }
        },
        /** 处理批量操作 **/
        handleBatchOperation(type, text) {
            if (this.selected.length) {
                let tips = type === 'enable' ? '是否确定要启用' : '确定停用该联系人？<br/>注：停用联系人会同步停用该联系人的登录账号。'
                this.$confirm(tips, text + '确认', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const codeArr = [];
                    this.selected.forEach(e => {
                        codeArr.push(String(e.id));
                    });
                    switch (type) {
                    case 'enable':
                        enablePersons(JSON.stringify({ id: codeArr })).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('启用成功!');
                                this.handleGetPerson();
                            }
                        });
                        break;
                    case 'disable':
                        disablePersons(JSON.stringify({ id: codeArr })).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('停用成功!');
                                this.handleGetPerson();
                            }
                        });
                        break;
                    }
                });
            } else {
                this.$message.warning('当前没有选中的数据');
            }
        },
        /** 权限分配 **/
        handlePermission(data) {
            if (data.userCode) {
                const row = {
                    sourceUserCode: this.$store.state.user.userCode,
                    userCode: data.userCode,
                    userType: userTypeToStatus(data.userType)
                };
                this.row = row;
                this.openPermissionDialog = true;
            } else {
                this.$message.warning('请生成账号！');
            }
        },
        closePermissionDialog(data) {
            this.openPermissionDialog = data;
            this.handleGetPerson();
            this.row = {
                sourceUserCode: '',
                userCode: '',
                userType: ''
            };
        },
        closeAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
            setTimeout(() => {
                this.id = '';
            }, THREE_HUNDRED);
        },
        confirmAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
            this.handleGetPerson();
            setTimeout(() => {
                this.id = '';
            }, THREE_HUNDRED);
        },
        formatData(data) {
            return data.map(item => {
                item.supplierStatus = this.dict.SYS_SUPPLIERS_STATUS[item.supplierStatus];
                item.onWayContactFlag_ = this.isLgtPptSup ? (['', null, undefined].includes(item.onWayContactFlag) ? '' : this.dict.ON_WAY_CONTACT_FLAG[item.onWayContactFlag]) : ''
                return item;
            });
        },
        handleHiddenEvent(data) {
            data.forEach(e => {
                e.hiddenEvent = [];
                if (e.userCode) { // 有账号，显示重置密码
                    e.hiddenEvent.push('create-account');
                } else { // 无账号，显示生成账号
                    e.hiddenEvent.push('reset-password');
                }
                if (e.isExistenceTenant || e.accountStatus === 0) { // 当前账号已绑定当前租户 或者 联系人账号状态停用，不需要展示绑定租户按钮
                    e.hiddenEvent.push('bind-tenant');
                }
                //当供应商类型=物流供应商、主体性质=个体时，列表操作区域隐藏“生成账号,重置密码,权限分配”button。
                // if(this.$store.state.supplier && this.$store.state.supplier.supplierType === LOGISTICS_SUPPLIER && this.$store.state.supplier.propertyNature === PERSON){
                //     e.hiddenEvent.push('create-account')
                //     e.hiddenEvent.push('reset-password')
                //     e.hiddenEvent.push('permission')
                // }
            });
            return data;
        },
        handleGetPerson(params = { pageNo: this.pageNo, pageSize: this.pageSize }) {
            this.searchObj.supplierCode = this.supplierCode;
            params = Object.assign(params, this.searchObj);
            getPersons(params).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                    this.totalData.forEach(e => {
                        e.contactsStatus = enableToLabel(e.contactsStatus);
                        e.accountStatusText = this.dict['SUPPLIER_UAER_ACCOUNT_STATUS'][e.accountStatus]
                        e.accountType = accountTypeToLabel(e.accountType);
                        e.userType = userTypeToLabel(e.userType);
                    });
                    this.totalData = this.formatData(this.totalData);
                    this.totalData = this.handleHiddenEvent(this.totalData);
                }
            });
        }
    },
    mounted() {
        dictWithUrl('SYS_SUPPLIERS_STATUS,SUPPLIER_UAER_ACCOUNT_STATUS,ON_WAY_CONTACT_FLAG').then(res => {
            this.dict = res.data;
            getLoginUser(this.$store.state.user.userCode).then(res => {
                if (res && res.code === '0') {
                    this.supplierCode = res.data.entityCode;
                    this.propertyNature = res.data.propertyNature;
                    this.handleGetPerson();
                }
            });
        });
    }
};
</script>

<style lang="less">
    .person-info {
        margin: 7px;
        min-width: 1200px;

        .enable-btn,
        .disable-btn {
            margin-left: 10px;
        }

        .tips-dialog {
            .el-dialog__body {
                height: 100px;
                line-height: 80px;
            }
        }

        .icon {
            overflow: hidden;
            width: 1em;
            height: 1em;
            vertical-align: -0.15em;
            fill: currentcolor;
            cursor: pointer;
        }

        .add-button {
            font-size: 28px;
        }
    }
</style>
